import { render } from "./addCertificate.vue?vue&type=template&id=ad9a9002"
import script from "./addCertificate.vue?vue&type=script&lang=js"
export * from "./addCertificate.vue?vue&type=script&lang=js"

import "./addCertificate.vue?vue&type=style&index=0&id=ad9a9002&lang=less"
script.render = render

export default script